export default "__VITE_ASSET__C7BfCaE1__"